import {Component, ContentChild, ContentChildren, HostBinding, Input, OnDestroy, QueryList} from "@angular/core";
import {FUIResponsiveService} from "../responsive.service";
import {FUIBreadcrumbsComponent} from "../../breadcrumbs/breadcrumbs.component";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {Subscription} from "rxjs";
import {FUIBreakpoints} from "../breakpoints.model";
import {FUIPageHeaderNavComponent} from "./page-header-nav/page-header-nav.component";

@Component({
    animations: [
        trigger("slide", [
            state("void", style({
                height: 0,
                "margin-bottom": 0,
                "margin-top": 0,
                opacity: 0,
                overflow: "hidden",
                "padding-bottom": 0,
                "padding-top": 0
            })),
            state("true", style({})),
            transition("* => *", animate("250ms ease-in-out"))
        ])
    ],
    selector: "fui-page-header",
    templateUrl: "./page-header.component.html",
    styleUrls: ["./page-header.component.scss"],
    standalone: false
})
export class FUIPageHeaderComponent implements OnDestroy {
    @Input() public title: string;
    @Input() public description: string;
    @Input() public isExtended: boolean;
    @Input() public hasToggle: boolean;
    @Input() public toggled: boolean;
    @Input() public label: string;
    @ContentChild(FUIBreadcrumbsComponent) public breadcrumbs: FUIBreadcrumbsComponent;
    @ContentChild(FUIPageHeaderNavComponent) public pageHeaderNav: FUIPageHeaderNavComponent;

    @HostBinding("attr.tabIndex") public tabIndex: number = 1;

    private subscriptions: Subscription = new Subscription();

    constructor(private responsiveService: FUIResponsiveService) {
        this.hasToggle = false;

        this.toggled = this.responsiveService.breakpointApplies(FUIBreakpoints.mediumUp);

        this.subscriptions.add(this.responsiveService.windowWidth$.subscribe(
            () => {
                this.toggled = this.responsiveService.breakpointApplies(FUIBreakpoints.mediumUp);
            }
        ));
    }

    /**
     * Toggle the header compacted state
     */
    toggle(toggle: boolean) {
        this.toggled = toggle;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
